// extracted by mini-css-extract-plugin
module.exports = {"titlea":"shared-styles_titlea__r567Q","title":"shared-styles_title__lHa8U","caption":"shared-styles_caption__lR2A6","captionSeparator":"shared-styles_captionSeparator__9NSx7"};